export const STATUS = {
  idle: 'idle',
  pending: 'pending',
  succeed: 'succeed',
  failed: 'failed'
} as const

export const MAG_DOOR_STATUS = {
  closed: 'closed',
  opened: 'opened',
} as const

export const MAG_LOCK_STATUS = {
  unlocked: 'unlocked',
  locked: 'locked',
} as const

export const GATE_STATUS = {
  closed: 'gate_closed',
  closing: 'gate_closing',
  opening: 'gate_opening',
  opened: 'gate_opened',
  stopped: 'gate_stopped',
  malfunction: 'gate_malfunction'
} as const

export const KNOWN_GATE_STATES: readonly string[] = Object.values(GATE_STATUS)

export const GATEWAY_STATUS = {
  closed: 'gateway_closed',
  opened: 'gateway_opened',
  unlocked: 'gateway_unlocked',
} as const

export const LOCATION_STATES = {
  popup: (p: string | object = '1') => { return { popup: p } },
  lastPage: 'end',
  menu: 'menu',
}

export const UNAUTHORIZED_TYPES = {
  password: 'password',
  webAuth: 'webauthn',
  device: 'device',
  phone: 'phone',
  mail: 'email',
  pin: 'pin',
  warehousePin: 'warehouse_pin',
  smsOtp: 'sms_otp',
  mailOtp: 'email_otp',
} as const